import EditCustomer from './EditCustomer'

export default EditCustomer



// WEBPACK FOOTER //
// ./src/components/Customers/Edit/index.js